module.exports = __webpack_public_path__ + "static/montaz_rozbijaczy_blachodachowki-f06db43ff813db2c574ba80e8b35691d.pdf";